import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=30cc5096&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"
import style0 from "./Legend.vue?vue&type=style&index=0&id=30cc5096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc5096",
  null
  
)

export default component.exports